import { Page } from 'components/Page';
import { Box } from '@mui/material';
export const WhatWeDo= () => <Page title="What We Do"> 

    <Box component="section" sx={{ p: 2, border: '1px dashed grey' }}>
      We develop educational websites.
    </Box>

</Page>